import React, { useState } from 'react';
import styled from 'styled-components';

import type { PatientRecords } from '@hooks/api/patient-record';

import emergencyBackground from '@images/emergency-access.jpg';

import type { MedicationStatementRecord } from '@models/medication';

import EmergencyDataPage from '@views/Emergency/EmergencyData';
import EmergencyLoginPage from '@views/Emergency/EmergencyLogin';

const Bg = styled.div`
  background-image: url(${emergencyBackground});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100vh;
`;

export default function EmergencyPage() {
  const [records, setRecords] = useState<PatientRecords | null>(null);
  const handleLogin = (emergencyData: PatientRecords) => {
    const activeMedicationStatement: MedicationStatementRecord[] =
      emergencyData.medication_statement.filter((medication) =>
        medication.isActive()
      );

    setRecords({
      ...emergencyData,
      medication_statement: activeMedicationStatement,
    });
  };

  return (
    <div>
      {records ? (
        <EmergencyDataPage records={records} />
      ) : (
        <Bg>
          <EmergencyLoginPage onLogin={handleLogin} />
        </Bg>
      )}
    </div>
  );
}
